<template>
  <div>
    <h1>Зарегистрироваться на игру <span v-if="gameSelected">"{{gameSelected.name}}"</span></h1>
    <template v-if="hasTeam">
      <div v-if="gameSelected">
        <template v-if="ifRegisteredToGame(gameSelected.id)">
          Вы уже зарегистрированы. Можете перейти к игре 
          <router-link :to="`/game/${gameSelected.id}`">Перейти к игре</router-link>
        </template>
        <template v-else>
          <el-button @click="registerToGame(gameSelected.id)">Зарегистрироваться</el-button>
        </template>
      </div>
      <div v-else>
        <h4>Выберите игру</h4>
        <el-row v-for="game in games" :key="game.id">
          <el-col :span="8">{{game.name}}</el-col>
          <el-col :span="8">
            <router-link v-if="ifRegisteredToGame(game.id)" :to="`/game/${game.id}`">Перейти к игре</router-link>
            <el-button v-else @click="registerToGame(game.id)">
              Зарегистрирваться
            </el-button>
          </el-col>
        </el-row>
      </div>
    </template>
    <template v-else>
        <el-row>Вам сначала нужно вступить в команду</el-row>
        <el-row>
          <el-col :span="8">Введите название команды</el-col>
          <el-col :span="8">
            <el-input
              v-model="existingTeamName"
              :class="{valid: teamExists, invalid: teamNotExists}"
            />
          </el-col>
          <el-col :span="8">
            <el-button
              @click="addToExistingTeam"
              :disabled="!teamExists"
              type="primary"
            >Добавиться в команду</el-button>
          </el-col>
        </el-row>
        <el-row>ИЛИ</el-row>
        <el-row>
          <el-col :span="8">Введите название новой команды</el-col>
          <el-col :span="8">
            <el-input v-model="newTeamName" :class="{invalid: !newTeamUnique}"/>
          </el-col>
          <el-col :span="8">
            <el-button
              @click="addToNewTeam"
              :disabled="!newTeamUnique || !newTeamName"
              type="primary"
          >Добавиться в новую команду</el-button></el-col>
        </el-row>
    </template>
  </div>
</template>

<script>
export default {
  name: 'RegisterToGame',
  data() {
    return {
      existingTeamName: null,
      newTeamName: null
    }
  },
  props: ['gameid'],
  computed: {
    user () {
      return this.$store.state.user;
    },
    hasTeam() {
      return this.user && this.user.team_id;
    },
    teamExists() {
      return this.existingTeamName && this.$store.state.teams.some(team => team.name == this.existingTeamName);
    },
    teamNotExists() {
      return this.existingTeamName && this.$store.state.teams.every(team => team.name != this.existingTeamName);
    },
    newTeamUnique() {
      return !this.newTeamName || this.$store.state.teams.every(team => team.name != this.newTeamName);
    },
    gameSelected() {
      return this.gameid && this.$store.getters.game(this.gameid);
    },
    games() {
      return this.$store.state.games;
    }
  },
  methods: {
    addToExistingTeam() {
      const team = this.$store.state.teams.find(t => t.name == t.existingTeamName);
      if(team) {
        this.$store.dispatch('addCurrentUserToTeam', team.id);
      }
    },
    addToNewTeam() {
      if(this.newTeamUnique) {
        this.$store.dispatch('addCurrentUserToNewTeam', this.newTeamName);
      }
    },
    registerToGame(game_id) {
      this.$store.dispatch('registerToGame', {team_id: this.user.team_id, game_id})
        .then(() => {
          this.$message({type: 'success', message: 'Успешно зарегистрировались на игру'});
        })
        .catch(err => this.$message({type: 'warning', message: `Error: ${err.message}`}));
    },
    ifRegisteredToGame(game_id) {
      return this.user.team_id && this.$store.getters.ifTeamRegisteredToGame(this.user.team_id, game_id);
    }
  }
}
</script>

<style>
  .valid {
    border: 1px solid green;
  }
  .invalid {
    border: 1px solid red;
  }
</style>